export default class TaxCertificateCtrl {
    constructor($scope, httpRequest, $location) {
        // 初始化
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                taxDiskType: '',
                levyWay: '',
                saleCreditCode: '',
                saleName: '',
                taxplayerType: '',
            },
        }
        $scope.reset = function () {
            $scope.param.param = {
                taxDiskType: '',
                levyWay: '',
                saleCreditCode: '',
                saleName: '',
                taxplayerType: '',
            }
        }
        // $scope.reset()
        httpRequest.get_dictByTypeArr('["tax_disk_type","taxplayer_type","levy_way","disk_type"]').then((res) => {
            $scope.dictionary = res.data.value
        })
        $scope.tableDropdownConfig = [{
            label: '编辑',
            handler(item) {
                $location.path(`/system/syssetting/taxCertificate/taxCertificateEdit/${item.saleId}`).replace()
            },
            showWhile() {
                return true
            },
        }]

        // 查询列表
        $scope.queryTaxInfo = function queryTaxInfo() {
            httpRequest.post_getSysSaleInfoList($scope.param).then((res) => {
                $scope.resData = res.data.value.list
                // 获取后台分页数据 回写分页组件
                $scope.totalItems = res.data.value.total //
            })
        }
        // 分页
        $scope.queryTaxInfo()
        $scope.customizedConfig = {
            version: 1.04,
            queryConfig: [
                {
                    label: '名称',
                    selected: true,
                    default: true,
                }, {
                    label: '信用代码',
                    selected: true,
                    default: true,
                }, {
                    label: '类型',
                    selected: true,
                    default: true,
                }, {
                    label: '计税方式',
                    selected: false,
                    default: false,
                }],
            table: [
                {
                    label: '名称',
                    selected: true,
                    default: true,
                }, {
                    label: '信用代码',
                    selected: true,
                    default: true,
                }, {
                    label: '类型',
                    selected: true,
                    default: true,
                }, {
                    label: '计税方式',
                    selected: true,
                    default: true,
                }, {
                    label: '开票方式',
                    selected: true,
                    default: true,
                }, {
                    label: '开户银行',
                    selected: true,
                    default: true,
                }, {
                    label: '进项数据采集方式',
                    selected: false,
                    default: false,
                },
            ],
        }
    }
}
TaxCertificateCtrl.$inject = ['$scope', 'httpRequest', '$location']



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/taxcertificate/taxCertificateCtrl.js